module.exports = "<div class=form-errors> <span translate>Required</span> </div> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/widgets/requirederror/partial.html
// module id = 553
// module chunks = 0